import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    addUsersToRole,getEmployesWithRole,
    removeRoleToUserByIds,
} from '../../../../../reduxToolkit/EmployeeRoles/EmployeeRolesApi';
import {errorMsg, userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
import {toast} from "react-toastify";
import {PersonChipBlack} from "../../../../../components/buttons/IconButtons";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: FullStack
 * @Email: kpozos@ibl.mx
 */
const ManageRoleApp = ({ onHide, selectedId, setModified }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [results, setResults] = useState([]);

    useEffect(() => {
        if (selectedId) getData();
    }, [selectedId]);

    /**
     * Fetches the list of employees associated with the selected role.
     *
     * Retrieves the employees assigned to a role and maps them into a UI-friendly format.
     * Updates local state with processed results.
     *
     * @function getData
     * @returns {void}
     */
    const getData = () => {
        dispatch(getEmployesWithRole(selectedId)).then(
            ({ payload: { data: { success, data } } }) => {
                if (success === true) {
                    setResults(userListToLabelEmailPhoneValue(data || [], "userId", false, PersonChipBlack));
                }
            }
        );
    };

    /**
     * Removes a user from the selected role.
     *
     * Sends a request to remove a single user (by ID) from the given role.
     * Refreshes the list on success and notifies parent component about modification.
     *
     * @function handleDelete
     * @param {string|number} dId - The ID of the user to be removed from the role.
     * @returns {void}
     */
    const handleDelete = (dId) => {
        const data = {
            userIds: [dId],
            roleId: selectedId,
        };

        dispatch(removeRoleToUserByIds(data)).then(
            ({ payload: { data: { success, code } } }) => {
                if (success === true) {
                    setModified(true);
                    getData();
                } else errorMsg(code);
            }
        );
    };

    /**
     * Adds multiple users to the selected role.
     *
     * Collects the provided users, extracts their IDs, and assigns them to the role.
     * Shows a success toast, flags modification, and closes the modal on success.
     *
     * @function handleAdd
     * @param {Array<{id: string|number}>} items - List of selected user objects.
     * @returns {void}
     */
    const handleAdd = (items) => {
        const all_user = items?.map((item) => item?.id);

        if (all_user?.length > 0) {
            const data = {
                userIds: all_user,
                roleId: selectedId,
            };

            dispatch(addUsersToRole(data)).then(
                ({ payload: { data: { success } } }) => {
                    if (success === true) {
                        toast.success(t('has_been_added_successfully'));
                        setModified(true);
                        onHide();
                    }
                }
            );
        }
    };

    return {
        t,
        handleDelete,
        handleAdd,
        selectedEmployee: results,
    };
};

export default ManageRoleApp;
